
import Vue from 'vue';
import {Action, Getter} from "vuex-class";

import {Component, Watch} from "vue-property-decorator";
import {IslemDurum, PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {acilisPlayerDurumu} from "@/utils/acilisPlayerDurumu";
import {botDongusuKurulmaliMi} from "@/utils/botDongusu";
import {otomatikIslemeIsteginiIsle} from "@/utils/otomatikIslemeMenuKoprusu";
import {
  ACILIS_VARSAYILAN_OTOMATIK_ISLEME,
  acilisTercihiniUygula,
  kullaniciSeciminiKaydet
} from "@/utils/otomatikIslemeTercihi";
import {baglantiOlayiSessizMi} from "@/utils/baglantiOlayi";
import {imzaMesajiniTemizle} from "@/utils/imzaMesaji";
import {Socket} from 'vue-socket.io-extended'
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {KimlikTenant} from "@/utils/aktifKimlik";
import SmartCardMenu from "@/components/appbar/SmartCardMenu.vue";
import KimlikGecisSeridi from "@/components/home/KimlikGecisSeridi.vue";
import OturumLimitiDialog from "@/components/dialogs/OturumLimitiDialog.vue";
import DevreKesiciDialog from "@/components/dialogs/DevreKesiciDialog.vue";
import KimlikUyusmazligiDialog from "@/components/dialogs/KimlikUyusmazligiDialog.vue";
import {gorevTamamlandiSesi, bildirimSesiAcikMi, bildirimSesiniAyarla} from "@/plugins/kritikUyari";
import Swal from "sweetalert2";
const { zirvelib } = window;

const LoadingView = () => import(/* webpackChunkName: "loading-view" */ '@/views/LoadingView.vue');
const DownloadView = () => import(/* webpackChunkName: "download-view" */ '@/views/DownloadView.vue');
const HomeView = () => import(/* webpackChunkName: "home-view" */ '@/views/HomeView.vue');
const UyapConnectionInfo = () => import(/* webpackChunkName: "uyap-connection-info" */ '@/infos/UyapConnectionInfo.vue');

@Component({
  components: {SmartCardMenu, KimlikGecisSeridi, OturumLimitiDialog, DevreKesiciDialog, KimlikUyusmazligiDialog, UyapConnectionInfo, DownloadView, LoadingView, HomeView}
})
export default class App extends Vue {
  private static _decoder = (typeof TextDecoder !== 'undefined') ? new TextDecoder('utf-8') : undefined;

  @Getter isUpdate!: boolean;
  @Getter isElectron!: boolean;
  @Getter isBrowser!: boolean;
  @Getter isUpdating!: boolean;
  @Getter isLoading!: boolean;
  @Getter uyapAvukatBilgileri!: KullaniciBilgileriCevap | undefined;
  @Getter uyapAvukatBakiye!: string | undefined;
  @Getter uyapSorguBakiye!: string | undefined;
  @Getter tenantBilgileri!: KimlikTenant | undefined;
  @Getter isEicraproBagli!: boolean;
  @Getter availableCardList!: any[];
  @Getter selectedCardSerial!: string | null;
  @Action load!: () => Promise<void>;
  @Action("availableCards") fetchAvailableCards!: (payload?: { silent?: boolean }) => Promise<void>;
  @Action("selectSmartCard") setSelectedSmartCard!: (serial: string | null) => void;

  @Getter getTamamlananGorevler!: Array<{ id: any }>;

  smartCardLoading = false;
  smartCardMenu = false;
  // Tamamlanmış ana görevlerin id'leri. İlk yüklemede yalnızca doldurulur;
  // aksi halde uygulama açılışında biriken görevler için ses çalardı.
  private gorulenTamamlananlar: Set<string> | null = null;
  private _smartCardMapCache?: {
    src: any[];
    mapped: Array<{ value: string; label: string; description?: string; tckn?: string }>;
  };

  @Watch('getTamamlananGorevler')
  onTamamlananGorevler(liste: Array<{ id: any }>) {
    const idler = new Set((liste ?? []).map((g) => String(g?.id)));
    if (this.gorulenTamamlananlar === null) {
      this.gorulenTamamlananlar = idler;
      return;
    }
    for (const id of idler) {
      if (!this.gorulenTamamlananlar.has(id)) {
        gorevTamamlandiSesi();
        break;
      }
    }
    this.gorulenTamamlananlar = idler;
  }

  @Socket('player')
  onPlayer(player: any) {
    this.$store.commit("setPlayerDurum", Number(player));
    // Kullanıcı Başlat'a bastı: kimlik uyuşmazlığının duraklatma anısı silinir (sonraki oturum
    // doğrulaması player'a dokunmaz). Kendi 'durduruluyor'/'dur' yankılarımız anıyı silmez.
    if (Number(player) === PlayerDurum.oto) {
      this.$store.commit('setKimlikDuraklatmasi', null);
    }
  }

  @Socket('availableCards')
  async onAvailableCards() {
    await this.fetchAvailableCards({ silent: true });
    // Vue'nun reaktif güncellemelerinin tamamlanmasını bekle
    await this.$nextTick();
    this._smartCardMapCache = undefined;
    await this.$nextTick();
    this.$socket.client.emit('availableCardsResponse', this.$store.state.availableCardList);
  }

  // Bot döngüsü (taskInterval) eskiden YALNIZ socket 'updateToken' olayında
  // kuruluyordu. Tarayıcı girişi bu uygulama açılmadan önce yapıldıysa ya da olay
  // socket'te kaçtıysa döngü hiç kurulmuyor, bot işaretli ama uykuda kalıyordu.
  // UYAP bağlantısı hangi yoldan gelirse gelsin (updateToken, connectToUyap,
  // kartla otomatik giriş, health check) döngü kurulur; taskInterval çift
  // başlatmaya karşı korumalı, dongu() koşulları (oto/BOSTA/bağlı) kendi denetler.
  @Watch('$store.getters.isUyapConnected')
  onUyapBaglantisiDegisti(bagli: boolean) {
    if (botDongusuKurulmaliMi(bagli, this.$store.state.gorevYoneticisi?.taskIntervalHandle ?? null)) {
      this.$store.dispatch('taskInterval');
    }
  }

  @Watch('$socket.connected')
  onSocketConnectionChange() {
    if (this.$socket.connected) {
      this.$socket.client.emit('refreshConnection');
      console.log("emit refreshConnection called");
      // Kabuk botKimligi'ni yeni bağlanan istemciye yeniden oynatır; imzacı da (yeniden) bağlanınca
      // güncel kimliğini yayınlar (eİcraPro rozeti).
      this.$store.dispatch('botKimligiYayinla');
    }
  }


  // Bayrağın tek kaynağı aktif kimliktir (bkz. utils/eicraproBaglantisi.ts, store/aktifKimlik.ts).
  private eicraproBagli(): boolean {
    return this.$store.getters.isEicraproBagli === true;
  }

  @Socket('updateTasks')
  onUpdateTask() {
    // Olayı eİcraPro kendi listesini tazeleyince yayınlıyor; imzacıda kimlik
    // yokken istek proxy'de "Host should not be empty" ile düşer. Tazeleme birleştirilir:
    // devir patlamaları (updateToken + bu olay) tek GET /api/v1/task olur.
    if (!this.eicraproBagli()) {
      return;
    }
    this.$store.dispatch('gorevListesiniTazele').catch(() => undefined);
  }

  @Socket('connectToUyap')
  onConnectToUyap(yuk?: { kaynak?: string }) {
    // Kabuk 2.0.5 yükü {kaynak} olarak iletir: 'kurtarma' bot isteğidir (kimse başında değil),
    // SESSİZ işlenir, PIN penceresi açılmaz. 'kurtarma-arayuz', yüksüz olay (icrapro-app
    // düğmeleri) ve kabuk <= 2.0.4 (yükü atar) eskisi gibi GÖRÜNÜR girişe gider.
    // İmzacının "bağlı" bayrağı bayat olabilir (boşta UYAP'a istek atmaz): action bayrağa güvenmez,
    // bağlıysa oturumu canlı doğrular; geçerliyse durumu yeniden yayınlar (tarayıcı beklemesin),
    // geçersizse sessiz yeniden bağlanmaya ilerler.
    if (baglantiOlayiSessizMi(yuk)) {
      this.$store.dispatch('tarayiciKurtarmasiniSurdur')
          .catch((e: unknown) => console.error('Bot UYAP bağlantısı sürdürülemedi.', e));
      return;
    }
    // connectToUyap başarısızlıkta throw eder; durum mesajı store'da zaten
    // set edildiği için burada sadece unhandled rejection engellenir.
    this.$store.dispatch('connectToUyap').catch((e: unknown) => console.error('UYAP bağlantısı başarısız.', e));
  }

  @Socket('openUyapWindow')
  onOpenUyapWindow() {
    this.$store.dispatch('openUyapWindow');
  }

  @Socket("notification")
  onNotification(notification: { message?: unknown, seconds?: number } | null | undefined) {
    // Mesajsız bildirim boş toast üretmesin.
    const metin = notification && typeof notification.message === 'string' ? notification.message.trim() : '';
    if (metin === '') {
      return;
    }
    this.$toast.info(metin);
  }

  // İmzacı uyarıları (İzinsiz İmza, kart bulunamadı, giriş hatası) socket'e
  // yayınlanıyordu ama bu uygulamada dinleyen yoktu: uyarı yalnızca icrapro-app'te
  // görünüyor, imzacı ekranında hiçbir şey çıkmıyordu.
  @Socket("imzaMessage")
  async onImzaMessage(message: unknown) {
    // Yük kabuk üzerinden gelir: yalnız kanonik alanlar geçer, başlık düz metin olarak
    // gösterilir, düğme metni kaçışlanır (utils/imzaMesaji.ts).
    const temiz = imzaMesajiniTemizle(message);
    if (temiz === null) {
      return;
    }
    await Swal.fire(temiz);
  }

  @Socket('updateToken')
  async onUpdateToken() {
    // Olay geldi diye "bağlı" sayılmaz: sessionStorage'daki ham ÖNERİ sunucudaki lisansla
    // doğrulanır ve aktif kimlik olur (yarım devir ve aynı öneri art arda gelirse sıfır istek;
    // tek uçuş). Aktif kimlik gelince UYAP oturumu devralma/otomatik giriş de oradan tetiklenir.
    await this.$store.dispatch('kimlikOnerisiniIsle', {neden: 'updateToken'});
    if (!this.eicraproBagli()) {
      return;
    }
    // Kart kimlik gelmeden takılıysa otomatik giriş o an kapıdan dönmüştü; şimdi
    // denenir. kartGecisi VERİLMEZ: updateToken eİcraPro'nun her oturum
    // kontrolünde gelir, sayaçları her seferinde sıfırlamak geri çekilmeyi
    // (login spam koruması) etkisiz bırakırdı. otomatikGirisDene önce UYAP'ta hâlâ geçerli
    // oturumu kart/PIN'siz DEVRALIR (pencere yenilemesinden sonra bayrak düşüktür; hız sınırlı),
    // e-imza ile yeni giriş yalnız kart ve PIN kapılarından sonra. updateToken devralma yoklaması
    // için TETİKLEYİCİDİR (oturumuYenidenYokla): önceki olumsuz yoklama bir sonrakini engellemez;
    // sağlık tiki ve bot döngüsü tetikleyici değildir.
    if (!this.$store.getters.isUyapConnected) {
      this.$store.dispatch('otomatikGirisDene', {oturumuYenidenYokla: true})
          .catch((e: unknown) => console.error('Otomatik giriş başarısız.', e));
    }
    this.$store.dispatch('gorevListesiniTazele')
        .catch(() => undefined)
        .then(() => this.$store.dispatch('taskInterval'));
    // Sonradan bağlanan tarayıcı sekmesi her devirde updateToken yayınlar; kabuk botKimligi'ni
    // tekrar oynatmasa da bu sekme güncel bilgiyi alır.
    this.$store.dispatch('botKimligiYayinla');
  }

  barokartBakiyeYukle() {
    window.open('https://barokart.com.tr/TL_Yukle.aspx', '_blank');
  }

  get tenantTitle(): string | null {
    return this.tenantBilgileri?.title ?? null;
  }

  get lawyerFullName(): string | null {
    if (this.uyapAvukatBilgileri?.adi && this.uyapAvukatBilgileri?.soyadi)
      return `${this.uyapAvukatBilgileri?.adi} ${this.uyapAvukatBilgileri?.soyadi}`;
    return null;
  }

  get barokartBalance(): string | null {
    const value = this.uyapSorguBakiye != null
      ? Number(this.uyapSorguBakiye)
      : undefined;
    return this.formatBalance(value);
  }

  get hasToolbarMeta(): boolean {
    return this.isElectron || this.toolbarChips.length > 0;
  }

  get toolbarChips(): Array<{ key: string; icon?: string; label: string; onClick?: () => void }> {
    const chips: Array<{ key: string; icon?: string; label: string; onClick?: () => void }> = [];
    if (this.tenantTitle) {
      chips.push({ key: 'tenant', icon: 'mdi-domain', label: this.tenantTitle });
    }
    if (this.lawyerFullName) {
      chips.push({ key: 'lawyer', icon: 'mdi-account-tie', label: this.lawyerFullName });
    }
    if (this.barokartBalance) {
      chips.push({
        key: 'barokart',
        icon: 'mdi-credit-card-outline',
        label: `Sorgu Bakiyesi: ${this.barokartBalance}`
      });
    }
    return chips;
  }

  get smartCardOptions(): Array<{ value: string; label: string; description?: string; tckn?: string }> {
    const src = this.availableCardList;
    if (!Array.isArray(src)) {
      return [];
    }
    if (this._smartCardMapCache?.src === src) {
      return this._smartCardMapCache.mapped;
    }
    const mapped = src.map((entry: any, index: number) => {
      // Yeni yapı: entry.certificate.certificateId, entry.certificate.subject, entry.terminal
      const serial = entry?.certificate?.certificateId ?? `card-${index}`;
      const holderRaw = entry?.certificate?.subject ?? null;
      const holderClean = this.cleanHolderName(holderRaw);
      const holder = holderClean ?? 'Bilinmeyen Sertifika';
      const reader = entry?.terminal ?? entry?.serialNumber ?? null;
      // subjectSerial düz metin TCKN (base64 değil)
      const tckn = this.extractTckn(entry?.certificate?.subjectSerial ?? null);
      const labelParts = [tckn, holder].filter(Boolean) as string[];
      return {
        value: serial,
        label: labelParts.length ? labelParts.join(' ') : serial,
        description: reader ? `Okuyucu: ${reader}` : undefined,
        tckn: tckn || undefined
      };
    });
    this._smartCardMapCache = { src, mapped };
    return mapped;
  }

  get smartCardSelectedLabel(): string {
    const selected = this.smartCardOptions.find(option => option.value === this.smartCardSelection);
    return selected?.label ?? 'Kart seç';
  }

  get smartCardButtonTitle(): string {
    const count = this.smartCardOptions.length;
    if (!count) {
      return 'Akıllı kart bulunamadı';
    }
    return `${this.smartCardSelectedLabel} (${count})`;
  }

  get smartCardSelection(): string | null {
    return this.selectedCardSerial ?? null;
  }

  set smartCardSelection(serial: string | null) {
    this.setSelectedSmartCard(serial ?? null);
  }

  private formatBalance(value: number | undefined): string | null {
    if (!value) {
      value = 0.00;
    }
    return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value) + "₺";
  }

  private base64ToUtf8(value?: string | null): string | undefined {
    if (!value) return undefined;
    try {
      const decoded = atob(value);
      // UTF-8 byte dizisini doğru şekilde decode et
      const bytes = new Uint8Array(decoded.length);
      for (let i = 0; i < decoded.length; i++) {
        bytes[i] = decoded.charCodeAt(i);
      }
      const decoder = (this.constructor as typeof App)._decoder;
      if (decoder) {
        return decoder.decode(bytes);
      }
      // Fallback for environments without TextDecoder - UTF-8 decode
      let result = '';
      let i = 0;
      while (i < bytes.length) {
        const byte1 = bytes[i++];
        if (byte1 < 0x80) {
          result += String.fromCharCode(byte1);
        } else if (byte1 < 0xE0) {
          const byte2 = bytes[i++];
          result += String.fromCharCode(((byte1 & 0x1F) << 6) | (byte2 & 0x3F));
        } else if (byte1 < 0xF0) {
          const byte2 = bytes[i++];
          const byte3 = bytes[i++];
          result += String.fromCharCode(((byte1 & 0x0F) << 12) | ((byte2 & 0x3F) << 6) | (byte3 & 0x3F));
        } else {
          const byte2 = bytes[i++];
          const byte3 = bytes[i++];
          const byte4 = bytes[i++];
          const codePoint = ((byte1 & 0x07) << 18) | ((byte2 & 0x3F) << 12) | ((byte3 & 0x3F) << 6) | (byte4 & 0x3F);
          result += String.fromCodePoint(codePoint);
        }
      }
      return result;
    } catch (_) {
      return value;
    }
  }

  private extractTckn(value?: string): string | undefined {
    if (!value) return undefined;
    const match = value.match(/\b\d{11}\b/);
    return match ? match[0] : undefined;
  }

  private cleanHolderName(value?: string | null): string | undefined {
    if (!value) return undefined;
    const normalized = value
        .replace(/[=,;:/]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    if (!normalized) return undefined;

    let tokens = normalized
        .split(/\s+/)
        .map(token => token.trim())
        .filter(token => token.length > 0);

    let prependAvukat = false;
    let sliceIndex = 0;

    const barosuIndex = tokens.findIndex(token => /BAROSU/i.test(token));
    if (barosuIndex >= 0) {
      sliceIndex = Math.max(sliceIndex, barosuIndex + 1);
      prependAvukat = true;
    }

    const avukatIndex = tokens.findIndex(token => /AVUKAT/i.test(token));
    if (avukatIndex >= 0) {
      sliceIndex = Math.max(sliceIndex, avukatIndex + 1);
      prependAvukat = true;
    }

    if (sliceIndex > 0) {
      tokens = tokens.slice(sliceIndex);
    }

    tokens = tokens.filter(token => !this.isNoiseToken(token));

    if (!tokens.length && prependAvukat) {
      return 'Avukat';
    }

    if (prependAvukat) {
      tokens.unshift('Avukat');
    }

    if (!tokens.length) {
      return undefined;
    }

    return tokens.join(' ');
  }

  private isNoiseToken(token: string): boolean {
    if (!token) return true;
    if (/\d{11}/.test(token)) return true;
    const upper = token.toUpperCase();
    const normalized = upper.replace(/\./g, '');
    const asciiNormalized = normalized
        .replace(/İ/g, 'I')
        .replace(/Ğ/g, 'G')
        .replace(/Ü/g, 'U')
        .replace(/Ş/g, 'S')
        .replace(/Ö/g, 'O')
        .replace(/Ç/g, 'C');
    const noiseTokens = new Set([
      'TC',
      'TCKN',
      'AVUKAT',
      'AV',
      'TR',
      'KIMLIK',
      'KIMLIKNO',
      'TCKIMLIK',
      'TCKIMLIKNO',
      'BAROSU',
      'BARO',
      'KAYITLI',
      'KAYITLIDIR',
      'NO',
      'NUMBER',
      'CN',
      'SERIALNUMBER',
      'SERINO',
      'SERI',
    ]);
    if (noiseTokens.has(normalized) || noiseTokens.has(asciiNormalized)) {
      return true;
    }
    if (/^[TCAVUKRNO]$/i.test(token)) {
      return true;
    }
    return false;
  }

  handleSmartCardSelect(serial: string) {
    this.smartCardSelection = serial;
    this.smartCardMenu = false;
  }

  handleSmartCardRefresh() {
    void this.refreshSmartCards(true);
  }

  async refreshSmartCards(showToast = false): Promise<void> {
    if (this.smartCardLoading) return;
    this.smartCardLoading = true;
    try {
      await this.fetchAvailableCards({ silent: !showToast });
      // Vue'nun reaktif güncellemelerinin tamamlanmasını bekle
      await this.$nextTick();
      this._smartCardMapCache = undefined;
      // İkinci bir nextTick ile computed property'nin yeniden hesaplanmasını zorla
      await this.$nextTick();
    } finally {
      this.smartCardLoading = false;
    }
  }

  // GEÇICI TEST FONKSIYONU - SONRA SİL
/*  async testSwalPopups() {
    await Swal.fire({
      title: "İzinsiz İmza",
      text: "Hesabınıza tanımlı kimlik numarası imza ile eşleşmiyor.",
      icon: "warning",
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Tamam'
    });

    await Swal.fire({
      title: "İmza Kartı Bulunamadı",
      text: "İmza kartının bilgisayara takılı olduğundan ve sürücülerinin yüklü olduğundan emin olun.",
      icon: "warning",
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Tamam'
    });

    await Swal.fire({
      title: 'İmza Pin Kodu',
      text: 'İmza: ANKARA BAROSU AVUKAT NİHAN ERDOĞAN',
      icon: "question",
      allowOutsideClick: false,
      showCancelButton: true,
      showConfirmButton: true,
      input: 'password',
      inputPlaceholder: 'PIN',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Vazgeç',
      confirmButtonColor: '#3085d6',
      confirmButtonText: 'Tamam',
    });
  }*/

  async mounted() {
    // Şifreli PIN deposu (kabuk 2.0.5 safeStorage) erken ve BEKLENMEDEN başlar; kart gözlemcisi
    // ve kart takılma kenarındaki otomatik giriş çözülmüş PIN'ler hazır olmadan çalışmasın diye
    // aşağıda refreshSmartCards'tan ÖNCE beklenir. Eski kabukta/tarayıcıda hemen çözülür.
    const pinHazir = this.$imza.pinDeposunuYukle()
        .catch((e: unknown) => console.error('PIN deposu yüklenemedi.', e));

    // Otomatik görev işleme tercihi localStorage'da kalıcı; state'e açılışta
    // yüklenmesi gerekiyor. Bu satır olmadan `state.autoPlay` bu uygulamada
    // HİÇBİR ZAMAN true olmuyordu (initAutoPlay yalnız plugin'de tanımlıydı,
    // kardeş uygulama icrapro-app onu commit ediyor, bot uygulaması etmiyordu).
    //
    // Bot açılışta KAPALI başlar (canlıdaki gibi 'dur'): otomatik sorgular UYAP
    // kısıtlaması yüzünden kapalı, isteyen Ayarlar menüsünden açar. Açılış değeri
    // `kullanıcı seçimi ?? ACILIS_VARSAYILAN_OTOMATIK_ISLEME` olarak türetilir ve
    // plugin kaydına HER açılışta yazılır (ayrıntı otomatikIslemeTercihi.ts
    // başlığında): plugin kayıt yokken tohumu kalıcı yazıp sonra saklı değeri
    // okuduğundan, türetme olmasa sabiti sonradan `true` yapmak mevcut
    // kullanıcıları açmazdı. Tohum varsayılanı BU uygulamaya özgüdür ve açıkça
    // verilir; icrapro-app'teki parametresiz çağrı da kapalıya düşer.
    acilisTercihiniUygula();
    this.$store.commit('initAutoPlay', ACILIS_VARSAYILAN_OTOMATIK_ISLEME);

    // Native Ayarlar menüsü köprüsü HEMEN kurulur (aşağıdaki await'lerden önce).
    // Kabuk menü işaretini varsayılan AÇIK kuruyor; durum zaten belli olduğundan
    // gerçek değer hemen bildirilmezse load() (imza/proxy servisleri) bitene dek
    // menü "açık" gösterir ve bu pencerede menüden tıklama dinleyicisiz kaybolurdu.
    zirvelib?.otomatikIslemeDurumunuBildir?.(this.$store.getters.getAutoPlay === true);
    zirvelib?.onOtomatikIslemeIstegi?.((istenen: boolean) => {
      otomatikIslemeIsteginiIsle(istenen, {
        tercihiYaz: (acik) => {
          this.$store.commit('updateAutoPlay', acik);
          // Menüden yapılan seçim (açık ya da kapalı) kullanıcı seçimidir; sabit
          // sonradan değişse de bu kullanıcının tercihi korunur.
          kullaniciSeciminiKaydet(acik);
        },
        playerDurumu: () => this.$store.getters.getPlayerDurum,
        playerEmit: (durum) => this.$socket.client.emit('player', durum),
        durumuBildir: (acik) => zirvelib?.otomatikIslemeDurumunuBildir?.(acik)
      }).catch(() => undefined);
    });

    await this.$router.push('/islemler');
    await this.load();

    // AÇILIŞTA PLAYER DURUMU TERCİHE GÖRE. Eskiden burada koşulsuz
    // `emit('player', dur)` vardı: kullanıcı otomatik işlemeyi Ayarlar'dan açık
    // bıraksa bile bot her açılışta duruyordu ve elle "Başlat" gerekiyordu.
    // Varsayılan artık KAPALI (yukarıdaki tohum): tercih açıkça açılmadıkça bot
    // canlıdaki gibi 'dur' başlar; açılmışsa beklemeye (oto) geçer.
    const acilisDurumu = acilisPlayerDurumu(this.$store.getters.getAutoPlay);
    // Durum önce YEREL store'a yazılır, socket'e ayrıca duyurulur. Eskiden yalnız
    // emit vardı ve store'daki player durumu imza servisinin geri yayınladığı
    // 'player' olayına bağlıydı: socket mount anında bağlı değilse olay kaybolur,
    // bot "otomatik açık" işaretine rağmen 'dur'da kalırdı (8 Eyl gündüz testi:
    // plan üretildi, sunucuya hiç next-task gelmedi).
    this.$store.commit('setPlayerDurum', acilisDurumu);
    this.$socket.client.emit('player', acilisDurumu);
    //this.$store.dispatch('getTasksFromServer').then(() => {
    //  this.$store.dispatch('taskInterval');
    //});
    await pinHazir;
    if (this.isElectron) {
      this.refreshSmartCards().catch(() => undefined);
    }
    // Bildirim sesi ayarı: sahibi burası (localStorage), Ayarlar menüsü yalnızca
    // işareti gösteriyor. Açılışta mevcut durumu bildir, sonra değişiklikleri dinle.
    zirvelib?.bildirimSesiDurumunuBildir?.(bildirimSesiAcikMi());
    zirvelib?.onBildirimSesiDegisti?.((acik: boolean) => {
      bildirimSesiniAyarla(acik);
    });
    zirvelib?.onAppCloseRequest(async () => {
      try {
        // Rota POST olarak tanımlı (routes/tenant.php); GET atıldığı için istek
        // 405 dönüyordu ve işlenen görevler ISLENIYOR durumunda takılı kalıyordu.
        if (this.$store.getters.getIslemDurum == IslemDurum.ISLENIYOR && this.eicraproBagli())
          await this.$http.post('/api/v1/task/islemleri-durdur');
      } finally {
        zirvelib?.sendAppCloseResponse();
      }
    });
    // UYAP bağlantısı health check başlat
    this.$store.dispatch('startHealthCheck');
    // Kart gözlemcisi: kart takılmasını gören tek yer. Boş → dolu geçişinde
    // otomatik giriş tetikleniyor, kullanıcının düğmeye basması gerekmiyor.
    if (this.isElectron) {
      this.$store.dispatch('kartGozlemcisiniBaslat');
    }
  }

  beforeDestroy() {
    // UYAP bağlantısı health check durdur
    this.$store.dispatch('stopHealthCheck');
    this.$store.dispatch('kartGozlemcisiniDurdur');
  }
}
